import ArrSVG from '@public/icons/btn-arr.svg';
import Button from '@/shared/components/shared/Button';
import Image from '@/shared/components/shared/Image';
import Link from '@/shared/components/shared/Link';
import Responsive from '@/shared/components/shared/Responsive';
import Typografed from '@/shared/components/shared/Typografed';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { NewsSectionProps } from '../NewsSection';

type Props = React.HTMLAttributes<HTMLElement> & {
    newsSectionProps: NewsSectionProps;
};

function ConstructorNewsSection({ newsSectionProps }: Props) {
    const tpTitle = useTypograf(newsSectionProps.title);

    return (
        <section
            className="constructor-news-section js-header-theme-trigger js-bg-trigger"
            data-bg="#ffffff"
            data-theme="dark"
        >
            <div className="constructor-news-top wrapper">
                <div className="constructor-news-title h3">{tpTitle}</div>
                <div className="constructor-news-description-block">
                    <Button tag={Link} href={newsSectionProps.btnSlug} variant="outline-dark">
                        Все новости
                    </Button>
                </div>
            </div>
            <div className="constructor-news-bottom wrapper">
                {newsSectionProps.newsSlider.map((slide, i) => (
                    <Link
                        href={`/news/${slide.categories[0].slug}/${slide.slug}/`}
                        className="constructor-news-slider-slide"
                        key={i}
                    >
                        <Responsive className="constructor-news-slider-img-wrapper">
                            {slide.img?.src && (
                                <Image
                                    className="constructor-news-slider-img"
                                    src={slide.img.src}
                                    alt={slide.img.alt || ''}
                                    width={slide.img.width}
                                    height={slide.img.height}
                                    sizes="(max-width: 768px) 60vw, 30vw"
                                />
                            )}
                        </Responsive>
                        <div className="constructor-news-slide-date">
                            <div className="text-xs">{slide.date}</div>
                            <div className="text-xs">
                                {slide.categories.map((category) => category.name).join(' / ')}
                            </div>
                        </div>
                        <div className="constructor-news-slide-title text-s">
                            <Typografed>{slide.title}</Typografed>
                        </div>
                        <div className="constructor-news-slide-btn">
                            <ArrSVG />
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}

export default ConstructorNewsSection;
